// Microsoft Clarity bootstrap, consent-gated.
//
// Loads the Clarity tracking script only AFTER the visitor has
// explicitly accepted analytics cookies via the CookieConsentBanner.
// Reads the project id from REACT_APP_CLARITY_PROJECT_ID so nothing
// is hardcoded. Does nothing when:
//   * the env var is missing (local dev without a Clarity project)
//   * the user has previously declined, or not yet decided
//   * the script tag has already been injected this session
//
// Masking: strictness is configured in the Clarity DASHBOARD
// (Project settings -> Masking -> Strict). The embed script does
// not take a mask flag; keep Strict toggled on there to keep
// passwords, emails, DMs out of recordings.

const CONSENT_KEY = 'zuriya_cookie_consent';
export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_DECLINED = 'declined';

export function getConsent() {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* storage disabled, treat as declined */
  }
}

export function clearConsent() {
  try {
    window.localStorage.removeItem(CONSENT_KEY);
  } catch {
    /* no-op */
  }
}

// Custom event the Footer "Cookie preferences" link fires to re-open
// the banner without the user having to clear localStorage.
export const COOKIE_PREFS_EVENT = 'zuriya:open-cookie-preferences';

export function openCookiePreferences() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(COOKIE_PREFS_EVENT));
}

export function loadClarity() {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  if (!projectId) return false;
  if (typeof window === 'undefined') return false;
  if (window.__zuriyaClarityLoaded) return true;
  if (getConsent() !== CONSENT_ACCEPTED) return false;

  // Standard Microsoft Clarity async tag, see
  // https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-setup
  (function (c, l, a, r, i) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    const t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);

  window.__zuriyaClarityLoaded = true;
  return true;
}
